<template>
  <a-layout-sider
    :width="settings.leftMenuWidth"
    :collapsible="settings.isMobileView ? false : true"
    :collapsed="settings.isMenuCollapsed && !settings.isMobileView"
    @collapse="onCollapse"
    :class="{
      [$style.menu]: true,
    }"
  >
    <div
      :class="$style.menuOuter"
      :style="{
        width: settings.isMenuCollapsed && !settings.isMobileView ? '80px' : settings.leftMenuWidth + 'px',
        height: settings.isMobileView || settings.isMenuUnfixed ? 'calc(100% - 64px)' : 'calc(100% - 110px)',
      }"
    >
      <div :class="$style.logoContainer">
        <div :class="$style.logo">
          <img :src="app.logo" class="" :alt="app.website_title" />
        </div>
      </div>
      <div :class="$style.wallet" v-if="!settings.isMenuCollapsed">
        <span>E-wallet</span>
        <div class="nominal"> {{ dashboard.ewallet | currency }} </div>
        <svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" enable-background="new 0 0 512 512" height="512" viewBox="0 0 512 512" width="512"><g><path d="m496 280.838v-80.838c0-13.234-10.767-24-24-24h-16v-152c0-13.234-10.767-24-24-24h-208c-13.233 0-24 10.766-24 24v8h-24c-13.233 0-24 10.766-24 24v24h-96c-30.879 0-56 25.122-56 56v320c0 30.878 25.121 56 56 56h416c13.233 0 24-10.766 24-24v-80.838c9.223-2.619 16-11.111 16-21.162v-84c0-10.051-6.777-18.542-16-21.162zm-280-256.838c0-4.411 3.589-8 8-8h208c4.411 0 8 3.589 8 8v152h-32.401c-4.027-40.37-38.187-72-79.599-72s-75.572 31.63-79.599 72h-32.401c0-20.76 0-139.928 0-152zm175.482 152h-126.964c3.951-31.525 30.903-56 63.482-56s59.531 24.475 63.482 56zm-223.482-120c0-4.411 3.589-8 8-8h24v128h-32c0-12.067 0-103.253 0-120zm-112 40h96v80c-102.543 0-96.516.025-98.04-.052-20.101-.999-36.718-17.116-37.889-37.646-1.338-22.931 16.988-42.302 39.929-42.302zm416 400h-416c-22.056 0-40-17.944-40-40 0-302.424-.197-281.005.399-280.406 9.208 9.218 21.071 14.824 33.873 16.115 3.653.368-23.031.291 421.728.291 4.411 0 8 3.589 8 8v80h-88c-35.29 0-64 28.71-64 64s28.71 64 64 64h88v80c0 4.411-3.589 8-8 8zm24-110c0 3.309-2.691 6-6 6h-98c-26.468 0-48-21.533-48-48s21.532-48 48-48h98c3.309 0 6 2.691 6 6z"/><path d="m392 320c-13.233 0-24 10.766-24 24s10.767 24 24 24 24-10.766 24-24-10.767-24-24-24zm0 32c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"/><path d="m240 120c4.418 0 8-3.582 8-8v-41.012c11.229-2.901 20.087-11.759 22.987-22.988h17.013c4.418 0 8-3.582 8-8s-3.582-8-8-8h-24c-4.418 0-8 3.582-8 8 0 8.822-7.178 16-16 16-4.418 0-8 3.582-8 8v48c0 4.418 3.582 8 8 8z"/><path d="m368 48h17.013c2.9 11.229 11.759 20.087 22.987 22.988v41.012c0 4.418 3.582 8 8 8s8-3.582 8-8v-48c0-4.418-3.582-8-8-8-8.822 0-16-7.178-16-16 0-4.418-3.582-8-8-8h-24c-4.418 0-8 3.582-8 8s3.582 8 8 8z"/><path d="m448 432c-4.418 0-8 3.582-8 8v8c0 4.411-3.589 8-8 8h-360c-4.418 0-8 3.582-8 8s3.582 8 8 8h360c13.233 0 24-10.766 24-24v-8c0-4.418-3.582-8-8-8z"/><path d="m72 232h360c4.411 0 8 3.589 8 8v8c0 4.418 3.582 8 8 8s8-3.582 8-8v-8c0-13.234-10.767-24-24-24h-360c-4.418 0-8 3.582-8 8s3.582 8 8 8z"/></g></svg>
      </div>
      <a-tabs />
      <vue-custom-scrollbar
        :style="{
          height: settings.isMobileView || settings.isMenuUnfixed ? 'calc(100vh - 64px)' : 'calc(100vh - 215px)',
          paddingBottom: '30px',
        }"
      >
        <a-menu
          forceSubMenuRender
          :inlineCollapsed="settings.isMobileView ? false : settings.isMenuCollapsed"
          :mode="'inline'"
          :selectedKeys="selectedKeys"
          :openKeys.sync="openKeys"
          @click="handleClick"
          @openChange="handleOpenChange"
          :inlineIndent="15"
          :class="$style.navigation"
        >
          <template v-for="(item, index) in menuData">
            <template v-if="!item.roles || item.roles.includes(user.seller_type)">
              <a-menu-item-group :key="index" v-if="item.category">
                <template slot="title">{{ item.title }}</template>
              </a-menu-item-group>
              <item
                v-if="!item.children && !item.category"
                :menu-info="item"
                :styles="$style"
                :key="item.key"
              />
              <sub-menu v-if="item.children" :menu-info="item" :styles="$style" :key="item.key" />
            </template>
          </template>
        </a-menu>

      </vue-custom-scrollbar>
    </div>
  </a-layout-sider>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import store from 'store'
import find from 'lodash/find'
import vueCustomScrollbar from 'vue-custom-scrollbar'
import { getMenuData } from '@/services/menu'
import SubMenu from './partials/submenu'
import Item from './partials/item'

export default {
  name: 'menu-left',
  components: { vueCustomScrollbar, SubMenu, Item },
  computed: {
    ...mapState(['settings', 'app', 'dashboard', 'user']),
    ...mapGetters('user', ['user']),
  },
  mounted() {
    // this.openKeys = store.get('app.menu.openedKeys') || ['store', 'account', 'sales']
    // this.selectedKeys = store.get('app.menu.selectedKeys') || []
    this.openKeys = ['store', 'account', 'sales', 'purchase']
    this.selectedKeys = []
    this.setSelectedKeys()
  },
  data() {
    return {
      menuData: getMenuData,
      selectedKeys: [],
      openKeys: [],
    }
  },
  watch: {
    'settings.isMenuCollapsed'(newVal) {
      if (!newVal) {
        this.openKeys = ['store', 'account', 'sales', 'purchase']
      } else {
        this.openKeys = []
      }
    },
    '$route'() {
      this.setSelectedKeys()
    },
  },
  methods: {
    onCollapse: function (collapsed, type) {
      const value = !this.settings.isMenuCollapsed
      this.$store.commit('settings/CHANGE_SETTING', { setting: 'isMenuCollapsed', value })
    },
    handleClick(e) {
      if (e.key === 'settings') {
        this.$store.commit('settings/CHANGE_SETTING', { setting: 'isSettingsOpen', value: true })
        return
      }
      store.set('app.menu.selectedKeys', [e.key])
      this.selectedKeys = [e.key]
    },
    handleOpenChange(openKeys) {
      store.set('app.menu.openedKeys', openKeys)
      this.openKeys = openKeys
    },
    setSelectedKeys() {
      const pathname = this.$route.path
      const menuData = this.menuData.concat()
      const flattenItems = (items, key) =>
        items.reduce((flattenedItems, item) => {
          flattenedItems.push(item)
          if (Array.isArray(item[key])) {
            return flattenedItems.concat(flattenItems(item[key], key))
          }
          return flattenedItems
        }, [])
      const selectedItem = find(flattenItems(menuData, 'children'), [
        'url',
        pathname,
      ])
      this.selectedKeys = selectedItem ? [selectedItem.key] : []
    },
  },
}
</script>

<style lang="scss" module>
@import "./style.module.scss";
</style>
